var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversity3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 118,
    viewBox: "0 0 380 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 117.931,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 117.931,
    fill: "url(#pattern0_1487_28984)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1487_28984",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1487_28984",
    transform: "matrix(0.00263158 0 0 0.00847953 0 -0.00877192)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1487_28984",
    width: 380,
    height: 120,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXwAAAB4CAYAAADxAUloAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATSSURBVHgB7d29a2RVH8Dx35mbZDI+MVkeV0FU1EVFES0EFVwLEURstBFB0WJRLK1EBBEsFBTEf0BLO0tbQQuttvGlEPGFFbdwkd1NVmVNMnOvZ8asCFrs5EbJ7u/zGW66c+9JJvnOnZnMuREAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAu1RiH+u67sNI5N3r7oy+Sr0tLi3F1Q8/EHe9+mIsLA/Pa9zP3x+Pj448F2e+Ox5dve3WoB5/OFqOKx+6P+5565XzHnf6y6/jk2dfiI0fjvc4esRC3Uara7F21+1x3ztvnfe4E0c/jc9ffiN++uqbaHtMYPoHtToaxRWPPBh3v/7SXGM/ef6VOPHBx7G1vhHjuPA9eexoJHOklHIs9rGF2N/uC+Y3KNFMQ9/NV67x5naUMvewf1B3UuY7l2gnk5hsbc6C2efws7Gli2Z4fg9055TpyK5E9J5BHT1oYlAfdOdVpodt22j3YA7wTwYBQAqCD5CE4AMkIfgASQg+QBKCD5CE4AMkIfgASQg+QBKCD5CE4AMkIfgASQg+QBKCD5DEfl8eGf4b3R8LIw+i38LEg50tujbm1e2sS93syRLV8HeCD1OlxOJwKYbLyzGJ3RvUWC9Or0UwmP/JcymD2cVrSp1DE7D3BB+qpbVLY+XWm2J8yajXFb+mzxKWl0exeujamNeBm2+I8an12D571uVP+FcIPlRrNx6KO157MfZEfT2m7OIM/5Znnoh4+vGAf4vgQ0xfTpn/sowX4xy4uPkvHYAkBB8gCcEHSELwAZIQfIAkBB8gCcEHSELwAZLwwSuoNjc3Y31jI7a3tqKvpmliNBrFgQMH5hq38c2x2F4/E23bZzWfHaXEZbfdEs10XR/YIfhQnT59Oj7/4os4depUTCbzr3R5zvTTspfU2B+8/GDce/jwXGO/fe/92Dj6WbS/bUbbaz2fEpO6h8NvvxkrV10ZcI7gQzUej+PkyZPx448n6hl2v+CvrKzU7X8xr7Mnfor1r7+LrV9+rcHuF/y2dNFtjwP+SvBhR9d2s9j3Df50XfuyizVxSjOIrg6b1PF9zvBnb8wNrMvD33nTFiAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEHyAJwQdIQvABkhB8gCQEnz91XVe/xN7o9mpHwF5ZCKi6to2mNnqpDKLtUf2mlNkvVTveDmB/EXxmltYujRufejTG62d6neSXujULC7F8/TUB7C+Cz8xwbTUOPfZwdJNJ7IXBcCmA/UXwmSlNE8sH/x/AxcubtgBJCD5AEoIPkITgAyQh+ABJCD5AEoIPkITgAyQh+ABJCD5AEoIPkITgAyQh+ABJCD5AEoIPkITgAyQh+ABJCD5AEoIPkITgAyQh+ABJCD5AEoIPkITgAyQh+ABJCD5AEoIPkMRC7G9HIpGubaOvrm5t3c/47Gbd3yQuFG2pZx/DYURpY1CnvduZT7//yXg7YmlxrnGllFhcXIgy3UNXYre66fB6N5amiXktrq7WydcdlEl0fe66ZvpjbOquuuA/tR4AAAAAAAAAAAAAAAAAXFh+B6yQ/OAso1y8AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity3);
export default __webpack_public_path__ + "static/media/university3.52e6a613174b4dee6bf2fa143669efcc.svg";
export { ForwardRef as ReactComponent };